import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

// import { createSessionStorage } from "./plugins/vuex-session";

const store = new Vuex.Store({
    // plugins: [createSessionStorage("<STATE_NAME>")],
    state: {
        lightboxData: [],
    },
    mutations: {
        updateLightbox(state, value) {
            state.lightboxData = value || [];
        }
    },
    getters: {
        getLightboxData(state) {
            return state.lightboxData;
        }
    }
});

export default store;
